import { Modal } from "antd";
import { createData } from "../../util/API";

export const KYC_REFRESH_EVENT = "kyc-notifications:refresh";
export const KYC_INCOMPLETE_CODE = "kyc_incomplete";

export function refreshKycNotifications() {
  window.dispatchEvent(new Event(KYC_REFRESH_EVENT));
}

function showKycBlockedMessage(partnerName) {
  Modal.warning({
    title: "KYC not verified",
    content: `KYC not verified for ${partnerName || "this partner"}. Finance has been notified — track it top right.`,
  });
}

function blockedBody(errorOrResponse) {
  const body =
    (errorOrResponse && errorOrResponse.response && errorOrResponse.response.data) ||
    (errorOrResponse && errorOrResponse.data) ||
    errorOrResponse;
  return body && body.code === KYC_INCOMPLETE_CODE ? body : null;
}

// True when the error/response is a KYC block; shows the message and refreshes the notification.
export function handleKycBlocked(errorOrResponse) {
  const body = blockedBody(errorOrResponse);
  if (!body) return false;
  showKycBlockedMessage(body.partner && body.partner.name);
  refreshKycNotifications();
  return true;
}

// Reports a partner pick. Resolves true when the partner must not be used.
export async function reportKycBlockedAttempt({ partner, attemptType, projectId, blockOnError = true }) {
  if (!partner || !partner.id) return false;
  try {
    const res = await createData("/finance/kyc-blocked-attempts/", {
      partner: partner.id,
      attempt_type: attemptType,
      project: projectId || null,
    });
    if (res && res.data && res.data.kyc_complete) return false;
    showKycBlockedMessage((res && res.data && res.data.partner && res.data.partner.name) || partner.name);
    refreshKycNotifications();
    return true;
  } catch (error) {
    if (!blockOnError) return false;
    showKycBlockedMessage(partner.name);
    return true;
  }
}
